import * as e from "react";
import c from "../lib/IconBase.es.js";
import s from "../defs/MinusCircle.es.js";
const o = e.forwardRef((r, i) => /* @__PURE__ */ e.createElement(c, { ref: i, ...r, weights: s }));
o.displayName = "MinusCircleIcon";
const a = o;
export {
  a as MinusCircle,
  o as MinusCircleIcon
};
